import { render, staticRenderFns } from "./ViewSuggestion.vue?vue&type=template&id=24d19e6e&scoped=true"
import script from "./ViewSuggestion.vue?vue&type=script&lang=js"
export * from "./ViewSuggestion.vue?vue&type=script&lang=js"
import style0 from "./ViewSuggestion.vue?vue&type=style&index=0&id=24d19e6e&prod&lang=scss&scoped=true"
import style1 from "./ViewSuggestion.vue?vue&type=style&index=1&id=24d19e6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d19e6e",
  null
  
)

export default component.exports